/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum UnitAmenityTag {
    ADA_UNIT = 'ada_unit',
    AFFORDABLE_SECTION_8 = 'affordable.section_8',
    AFFORDABLE_LIHTC = 'affordable.lihtc',
    BALCONY_PATIO = 'balcony_patio',
    BALCONY_PATIO_ENCLOSED = 'balcony_patio.enclosed',
    BALCONY_PATIO_LARGE = 'balcony_patio.large',
    BALCONY_PATIO_PRIVATE = 'balcony_patio.private',
    BALCONY_PATIO_SMALL = 'balcony_patio.small',
    BALCONY_PATIO_STORAGE = 'balcony_patio.storage',
    CORNER_UNIT = 'corner_unit',
    DEN = 'den',
    DISHWASHER = 'dishwasher',
    DOUBLE_OCCUPANCY = 'double_occupancy',
    FIREPLACE = 'fireplace',
    FLOOR = 'floor',
    FLOOR_PENTHOUSE = 'floor.penthouse',
    GARAGE = 'garage',
    GARAGE_ATTACHED = 'garage.attached',
    GARAGE_DETACHED = 'garage.detached',
    GARAGE_ONE_CAR = 'garage.one_car',
    GARAGE_TWO_CAR = 'garage.two_car',
    KITCHEN_ISLAND = 'kitchen_island',
    KITCHEN_ISLAND_LARGE = 'kitchen_island.large',
    RENOVATED = 'renovated',
    RENOVATED_FULLY = 'renovated.fully',
    RENOVATED_PARTIALLY = 'renovated.partially',
    RENOVATED_RECENTLY = 'renovated.recently',
    SMARTHOME = 'smarthome',
    STAINLESS_STEEL_APPLIANCES = 'stainless_steel_appliances',
    TOWNHOME = 'townhome',
    URBAN_1BR = 'urban_1br',
    VIEW = 'view',
    VIEW_CITY = 'view.city',
    VIEW_COURTYARD = 'view.courtyard',
    VIEW_DIRECTION = 'view.direction',
    VIEW_MOUNTAINS = 'view.mountains',
    VIEW_POOL = 'view.pool',
    VIEW_WATER = 'view.water',
    VIEW_WOODS = 'view.woods',
    WALK_IN_CLOSET = 'walk_in_closet',
    WALK_IN_CLOSET_LARGE = 'walk_in_closet.large',
    WASHER_DRYER = 'washer_dryer',
    WASHER_DRYER_FULL_SIZE = 'washer_dryer.full_size',
    WASHER_DRYER_STACKABLE = 'washer_dryer.stackable',
    WASHER_DRYER_CONNECTIONS = 'washer_dryer_connections',
}
